import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg/Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 340 323"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M174.505 323C263.699 323 336.005 250.694 336.005 161.5C336.005 72.306 263.699 0 174.505 0C85.3114 0 13.0054 72.306 13.0054 161.5C13.0054 250.694 85.3114 323 174.505 323Z",
                fill: "url(#paint0_radial_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M59.9619 182.34H288.78C289.633 178.609 290.326 174.772 290.859 170.881H57.9365C58.4162 174.772 59.1091 178.556 59.9619 182.34Z",
                fill: "url(#paint1_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M81.6018 227.699H267.14C268.952 225.354 270.711 222.955 272.364 220.45H76.4316C78.084 222.902 79.7896 225.354 81.6018 227.699Z",
                fill: "url(#paint2_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M95.6728 242.783H253.175C255.254 240.917 257.279 238.945 259.198 236.92H89.6499C91.5687 238.999 93.5941 240.917 95.6728 242.783Z",
                fill: "url(#paint3_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M116.62 257.921H232.228C234.68 256.535 237.079 255.042 239.477 253.497H109.424C111.716 255.042 114.168 256.535 116.62 257.921Z",
                fill: "url(#paint4_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M64.5991 197.425H284.196C285.422 194.12 286.542 190.816 287.501 187.351H61.2944C62.2538 190.816 63.3731 194.174 64.5991 197.425Z",
                fill: "url(#paint5_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M71.6343 212.561H277.16C278.706 209.736 280.198 206.858 281.478 203.927H67.2637C68.5962 206.858 70.0886 209.736 71.6343 212.561Z",
                fill: "url(#paint6_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M56.9238 155.637C56.9238 159.528 57.137 163.419 57.5101 167.203H291.339C291.712 163.419 291.925 159.528 291.925 155.637C291.925 155.211 291.925 154.784 291.925 154.358H56.9238C56.9238 154.784 56.9238 155.211 56.9238 155.637Z",
                fill: "url(#paint7_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M58.2567 137.835C57.5638 142.525 57.1374 147.269 56.9775 152.066H291.819C291.659 147.216 291.233 142.472 290.54 137.835H58.2567Z",
                fill: "url(#paint8_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M170.72 273.058H178.075C186.017 272.791 193.799 271.778 201.314 270.02H147.481C154.996 271.778 162.725 272.791 170.72 273.058Z",
                fill: "url(#paint9_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M174.398 38.1631C115.874 38.1631 67.3705 80.9632 58.416 136.982H290.379C281.425 80.9632 232.921 38.1631 174.398 38.1631Z",
                fill: "url(#paint10_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M234.309 106.76L210.803 176.744H231.537L233.776 170.081H255.789L258.027 176.744H278.708L254.989 106.76H234.309ZM238.253 156.863L244.756 137.621L251.258 156.863H238.253Z",
                fill: "url(#paint11_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M259.308 174.985L257.069 168.322H232.551L230.312 174.985H213.31L235.642 108.466H253.818L276.311 174.985H259.308ZM235.856 158.622H253.765L244.81 132.185L235.856 158.622Z",
                fill: "url(#paint12_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M260.267 145.297C258.508 145.936 257.655 147.908 255.737 148.068C253.658 148.228 251.366 145.51 249.554 144.817C249.394 144.764 249.181 144.71 248.968 144.604L253.711 158.622H235.802L239.853 146.683C239.32 147.002 238.734 147.216 237.881 147.109C235.962 146.896 234.736 144.977 233.031 144.231C229.086 142.578 226.315 145.243 222.904 146.363L213.31 175.038H230.312L232.551 168.376H257.069L259.308 175.038H276.311L266.343 145.563C266.13 145.51 265.917 145.457 265.651 145.35C264.158 144.977 261.76 144.764 260.267 145.297Z",
                fill: "url(#paint13_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M316.284 106.547L300.667 130.959V106.654H281.053V176.957H300.667V152.865L316.071 176.904H339.363L316.977 141.939L339.576 106.601H316.284V106.547Z",
                fill: "url(#paint14_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M282.811 175.198V108.466H298.961V136.981L317.296 108.306H336.431L314.951 141.885L336.218 175.145H317.083L298.961 146.842V175.145H282.811V175.198Z",
                fill: "url(#paint15_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M298.909 146.842L317.031 175.145H336.166L314.899 141.885L316.818 138.847C316.391 138.687 315.965 138.581 315.485 138.581C312.66 138.474 311.328 141.192 308.769 141.299C305.465 141.352 304.559 138.314 300.881 140.02C296.777 141.885 298.003 140.926 294.005 139.38C290.594 138.048 290.381 141.086 287.716 141.033C286.863 140.979 285.424 139.274 284.305 139.007C283.665 138.847 283.185 138.847 282.706 138.954V175.251H298.856V146.842H298.909Z",
                fill: "url(#paint16_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M195.133 153.078C195.133 156.063 192.735 158.462 189.75 158.462C186.765 158.462 184.366 156.063 184.366 153.078V147.695H164.752V153.078C164.752 166.883 175.945 178.076 189.75 178.076C203.555 178.076 214.748 166.883 214.748 153.078V107.773H195.133V153.078Z",
                fill: "url(#paint17_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M189.75 176.317C176.904 176.317 166.511 165.87 166.511 153.078V149.454H182.661V153.078C182.661 157.022 185.859 160.22 189.803 160.22C193.747 160.22 196.945 157.022 196.945 153.078V109.479H213.095V153.078C212.989 165.924 202.595 176.317 189.75 176.317Z",
                fill: "url(#paint18_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M189.75 176.317C202.595 176.317 212.989 165.87 212.989 153.078V138.9C212.509 139.06 212.083 139.167 210.963 138.954C209.577 138.74 208.725 137.621 207.126 137.781C205.42 137.941 205.047 139.433 203.768 139.7C201.529 140.233 200.623 138.421 198.331 138.047C197.798 137.941 197.318 137.994 196.839 138.047V153.078C196.839 157.022 193.641 160.22 189.696 160.22C185.752 160.22 182.554 157.022 182.554 153.078V149.454H166.511V153.078C166.511 165.924 176.958 176.317 189.75 176.317Z",
                fill: "url(#paint19_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M84.9607 108.893L74.2474 144.924L63.4807 108.893H62.4147H43.0134H41.9474L31.234 144.977L20.4673 108.893H0L21.0003 179.409L20.8937 179.622H21.0536H41.4144H41.521L41.4677 179.409L52.714 141.512L64.0137 179.409L63.9071 179.622H64.067H84.3744H84.5343L84.481 179.409L105.428 108.893H84.9607Z",
                fill: "url(#paint20_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M65.3462 177.863L52.714 135.33L40.0818 177.863H22.3328L2.34521 110.598H19.1881L31.234 151.107L43.2266 110.598H62.2015L74.2474 151.107L86.2399 110.598H103.083L83.0952 177.863H65.3462Z",
                fill: "url(#paint21_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M43.4934 145.084C42.1609 145.35 41.4147 146.416 40.0822 146.843C37.5238 147.695 35.1252 146.043 32.8866 145.51L31.2343 151.107L29.7419 146.043C28.9957 146.736 28.1962 147.749 27.3967 148.068C24.9449 149.081 21.8002 148.388 19.295 147.535C17.4295 146.896 16.7366 145.99 14.498 145.936C13.965 145.936 13.432 145.936 12.8457 145.99L22.3332 177.863H40.0822L49.5696 145.99C47.5442 145.35 45.4655 144.711 43.4934 145.084Z",
                fill: "url(#paint22_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M90.3981 146.043C88.5859 146.15 87.1468 145.51 85.4412 145.51C83.4157 145.51 83.0959 146.843 81.337 147.322C79.205 147.962 77.6593 146.416 75.7405 146.043L74.2481 151.107L72.809 146.31C72.2227 146.576 71.6364 146.949 70.7836 147.376C65.9865 149.774 64.7606 145.936 60.3367 146.043C58.5778 146.096 57.4585 146.683 56.126 147.002L65.2936 177.863H83.0426L92.4768 146.043C91.8372 145.99 91.091 145.99 90.3981 146.043Z",
                fill: "url(#paint23_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M131.279 109.159C113.797 109.159 99.5654 124.883 99.5654 144.231C99.5654 163.579 113.743 179.302 131.279 179.302C148.762 179.302 162.993 163.579 162.993 144.231C162.993 124.883 148.815 109.159 131.279 109.159ZM131.279 157.076C124.883 157.076 119.66 151.32 119.66 144.231C119.66 137.142 124.83 131.385 131.279 131.385C137.675 131.385 142.899 137.142 142.899 144.231C142.899 151.32 137.675 157.076 131.279 157.076Z",
                fill: "url(#paint24_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M131.279 177.543C114.755 177.543 101.324 162.619 101.324 144.23C101.324 125.842 114.755 110.918 131.279 110.918C147.802 110.918 161.233 125.842 161.233 144.23C161.233 162.619 147.802 177.543 131.279 177.543ZM131.279 129.679C123.923 129.679 117.953 136.235 117.953 144.284C117.953 152.332 123.923 158.888 131.279 158.888C138.634 158.888 144.604 152.332 144.604 144.284C144.657 136.182 138.634 129.679 131.279 129.679Z",
                fill: "url(#paint25_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M160.435 141.779C157.237 142.099 153.932 143.858 150.681 143.271C148.762 142.952 147.749 141.406 145.777 141.513C145.351 141.566 144.871 141.672 144.445 141.779C144.551 142.579 144.658 143.378 144.658 144.231C144.658 152.279 138.688 158.835 131.333 158.835C123.977 158.835 118.008 152.279 118.008 144.231C118.008 143.911 118.008 143.645 118.061 143.325C116.568 142.952 115.076 142.632 113.317 142.898C111.079 143.218 108.094 145.137 105.962 144.444C104.736 144.071 104.309 142.472 102.977 142.099C102.497 141.939 102.017 141.992 101.484 142.046C101.431 142.792 101.431 143.485 101.431 144.231C101.431 162.62 114.863 177.544 131.386 177.544C147.909 177.544 161.341 162.62 161.341 144.231C161.341 143.378 161.287 142.579 161.234 141.726C160.914 141.779 160.701 141.726 160.435 141.779Z",
                fill: "url(#paint26_linear_193_720)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M79.3649 251.258C79.0984 251.311 78.8852 251.311 78.6187 251.258C77.8192 251.045 77.4994 250.138 77.8725 249.339C82.2964 240.118 89.7052 227.592 96.9007 215.493C107.188 198.171 122.698 172.053 119.234 169.388C118.967 169.175 118.274 169.175 117.368 169.335C107.241 171.361 74.2481 196.678 64.2809 207.765C64.2809 207.765 64.2809 207.765 64.3342 207.765C65.187 207.818 65.72 208.617 65.4535 209.47C65.187 210.323 64.2809 210.963 63.4281 210.909C62.6286 210.856 60.9763 210.376 60.6032 209.097C60.39 208.404 60.6032 207.605 61.1362 206.965C69.8241 196.678 105.109 168.696 117.368 166.244C119.18 165.924 120.619 166.031 121.525 166.777C126.589 170.668 116.515 188.257 99.619 216.666C92.4768 228.712 85.068 241.131 80.7507 250.192C80.5375 250.725 79.9512 251.151 79.3649 251.258Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M66.8393 233.562C66.0931 233.722 65.4002 233.349 65.2403 232.656C65.0271 231.857 65.6134 230.95 66.4662 230.577C74.5678 227.379 99.619 219.011 104.896 217.625C105.749 217.412 106.601 217.892 106.655 218.691C106.708 219.544 106.068 220.397 105.162 220.663C100.525 221.889 75.5273 230.204 67.1591 233.509C67.0525 233.509 66.9459 233.562 66.8393 233.562Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M77.4992 249.872C77.2327 249.926 77.0195 249.926 76.753 249.872C75.9535 249.659 75.6337 248.753 76.0068 247.953C80.4307 238.732 87.8394 226.207 95.035 214.108C105.322 196.785 120.832 170.668 117.368 168.003C117.101 167.79 116.408 167.79 115.502 167.95C105.375 169.975 72.3823 195.293 62.4152 206.379C62.4152 206.379 62.4152 206.379 62.4685 206.379C63.3213 206.432 63.8543 207.232 63.5878 208.085C63.3213 208.938 62.4152 209.577 61.5624 209.524C60.7629 209.471 59.1106 208.991 58.7375 207.712C58.5243 207.019 58.7375 206.219 59.2705 205.58C67.9584 195.293 103.243 167.31 115.502 164.858C117.315 164.538 118.754 164.645 119.66 165.391C124.723 169.282 114.65 186.871 97.7533 215.28C90.6111 227.326 83.2023 239.745 78.885 248.806C78.6718 249.339 78.0855 249.712 77.4992 249.872Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M64.9199 232.123C64.1737 232.283 63.4808 231.91 63.3209 231.217C63.1077 230.417 63.694 229.511 64.5468 229.138C72.6484 225.94 97.6996 217.572 102.976 216.186C103.829 215.973 104.682 216.453 104.735 217.252C104.789 218.105 104.149 218.958 103.243 219.224C98.6057 220.45 73.6078 228.765 65.2397 232.07C65.1864 232.07 65.0798 232.123 64.9199 232.123Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M177.224 224.714C176.691 224.821 176.265 224.714 175.838 224.554C175.465 224.341 174.985 223.968 174.879 223.168C174.612 221.516 176.105 218.158 179.09 213.255C170.188 223.222 164.325 228.712 161.127 226.207C155.691 222.049 168.536 205.686 169.975 203.82C173.386 199.556 181.701 189.856 185.805 192.201C187.777 193.32 186.232 197.744 184.953 199.823C184.473 200.622 183.46 201.049 182.714 200.729C181.968 200.409 181.755 199.503 182.234 198.65C183.034 197.318 183.46 195.719 183.513 194.973C181.648 195.239 174.559 201.582 168.27 211.069C163.579 218.105 162.3 222.689 163.419 223.542C165.072 224.821 176.904 211.336 181.381 206.272C184.473 202.808 187.351 199.503 189.909 196.838C190.549 196.198 191.455 196.039 192.095 196.412C192.734 196.838 192.788 197.691 192.308 198.437L191.455 199.716C188.47 204.087 180.049 216.399 178.397 220.823C181.488 218.265 188.364 210.27 193.107 204.727C198.278 198.704 203.181 192.947 206.113 190.389C206.859 189.749 207.872 189.696 208.405 190.282C208.938 190.868 208.778 191.881 208.032 192.521C205.313 194.919 200.303 200.782 195.399 206.485C184.26 219.437 179.836 224.181 177.224 224.714Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M175.358 223.275C174.825 223.382 174.399 223.275 173.972 223.115C173.599 222.902 173.12 222.529 173.013 221.729C172.747 220.077 174.239 216.719 177.224 211.815C168.323 221.783 162.46 227.272 159.262 224.767C153.825 220.61 166.67 204.247 168.109 202.381C171.521 198.117 179.836 188.417 183.94 190.762C185.912 191.881 184.366 196.305 183.087 198.384C182.607 199.183 181.594 199.61 180.848 199.29C180.102 198.97 179.889 198.064 180.369 197.211C181.168 195.879 181.594 194.28 181.648 193.533C179.782 193.8 172.693 200.143 166.404 209.63C161.713 216.666 160.434 221.25 161.554 222.102C163.206 223.382 175.038 209.897 179.516 204.833C182.607 201.369 185.485 198.064 188.044 195.399C188.683 194.759 189.589 194.599 190.229 194.972C190.869 195.399 190.922 196.252 190.442 196.998L189.589 198.277C186.605 202.648 178.183 214.96 176.531 219.384C179.622 216.826 186.498 208.831 191.242 203.287C196.412 197.264 201.316 191.508 204.247 188.95C204.993 188.31 206.006 188.257 206.539 188.843C207.072 189.429 206.912 190.442 206.166 191.082C203.448 193.48 198.437 199.343 193.534 205.046C182.341 217.998 177.917 222.742 175.358 223.275Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M231.324 214.054C231.217 214.054 231.164 214.107 231.057 214.107C229.565 214.32 228.659 213.84 228.179 213.361C223.969 209.523 229.405 200.249 232.976 195.079C237.24 188.896 245.449 179.515 249.393 180.528C250.459 180.794 251.152 181.487 251.418 182.5C252.004 184.632 250.512 187.883 249.393 189.536C248.86 190.335 247.847 190.655 247.101 190.282C246.355 189.909 246.248 188.949 246.781 188.15C247.687 186.871 248.487 184.738 248.273 183.832C248.22 183.672 248.167 183.619 248.007 183.566C245.982 183.726 236.814 193 232.177 202.008C229.885 206.378 229.352 209.63 230.684 210.802C230.738 210.856 230.844 210.962 231.271 210.909C235.321 210.323 245.982 200.675 263.091 182.18C264.317 180.848 265.223 179.835 265.756 179.302C266.449 178.609 267.462 178.449 268.048 178.982C268.634 179.515 268.581 180.528 267.888 181.221C267.355 181.754 266.449 182.713 265.276 183.992C252.218 198.223 237.987 212.774 231.324 214.054Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M229.405 212.615C229.298 212.615 229.245 212.669 229.138 212.669C227.646 212.882 226.74 212.402 226.26 211.923C222.049 208.085 227.486 198.811 231.057 193.641C235.321 187.458 243.529 178.077 247.473 179.09C248.539 179.356 249.232 180.049 249.499 181.062C250.085 183.194 248.593 186.445 247.473 188.097C246.94 188.897 245.928 189.217 245.181 188.843C244.435 188.47 244.329 187.511 244.862 186.711C245.768 185.432 246.567 183.3 246.354 182.394C246.301 182.234 246.247 182.181 246.088 182.128C244.062 182.288 234.894 191.562 230.257 200.57C227.965 204.94 227.432 208.192 228.765 209.364C228.818 209.417 228.925 209.524 229.351 209.471C233.402 208.884 244.062 199.237 261.172 180.742C262.397 179.409 263.304 178.397 263.837 177.864C264.529 177.171 265.542 177.011 266.128 177.544C266.715 178.077 266.661 179.09 265.969 179.782C265.436 180.315 264.529 181.275 263.357 182.554C250.298 196.785 236.12 211.336 229.405 212.615Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M254.456 211.869C254.403 211.869 254.35 211.869 254.297 211.869C253.071 212.029 252.378 211.656 252.005 211.336C250.139 209.63 250.033 206.432 251.632 201.849C255.149 191.935 266.396 177.011 271.672 175.198C273.271 174.665 274.178 175.252 274.551 175.625C275.137 176.211 275.723 177.384 275.137 179.356C273.431 185.219 262.025 195.399 258.934 197.052C258.241 197.425 257.548 197.318 257.121 196.892C256.748 197.585 256.375 198.331 256.055 199.077C253.71 203.981 253.124 207.498 254.403 208.778C258.188 208.831 279.135 188.15 291.66 173.973C292.3 173.226 293.312 173.066 293.952 173.546C294.592 174.026 294.592 175.039 293.952 175.731C293.632 176.105 263.038 210.217 254.456 211.869ZM272.099 178.183C270.127 178.823 263.891 185.645 259.04 193.587C262.611 190.922 270.873 183.087 271.992 179.089C272.205 178.61 272.152 178.343 272.099 178.183Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M252.591 210.43C252.537 210.43 252.484 210.43 252.431 210.43C251.205 210.59 250.512 210.217 250.139 209.897C248.273 208.191 248.167 204.993 249.766 200.409C253.284 190.496 264.53 175.571 269.807 173.759C271.406 173.226 272.312 173.813 272.685 174.186C273.271 174.772 273.858 175.945 273.271 177.917C271.566 183.78 260.159 193.96 257.068 195.612C256.375 195.985 255.682 195.879 255.256 195.452C254.883 196.145 254.51 196.892 254.19 197.638C251.845 202.541 251.258 206.059 252.537 207.338C256.322 207.392 277.269 186.711 289.794 172.533C290.434 171.787 291.447 171.627 292.086 172.107C292.726 172.587 292.726 173.599 292.086 174.292C291.766 174.665 261.119 208.778 252.591 210.43ZM270.233 176.744C268.261 177.384 262.025 184.206 257.175 192.148C260.746 189.483 269.007 181.648 270.127 177.65C270.286 177.17 270.286 176.904 270.233 176.744Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M108.2 242.143C107.827 242.196 107.507 242.196 107.188 242.09C106.175 241.77 105.482 241.077 105.162 239.958C103.67 234.628 112.944 219.331 118.594 210.696C119.127 209.896 120.14 209.523 120.886 209.896C121.632 210.27 121.792 211.176 121.259 211.975C112.731 225.034 107.507 235.694 108.307 238.625C108.36 238.732 108.36 238.839 108.414 238.892C110.119 237.773 114.65 232.443 118.647 227.699C124.244 221.143 131.226 212.935 137.729 206.965C138.475 206.325 139.488 206.272 140.021 206.805C140.554 207.391 140.447 208.404 139.701 209.044C133.358 214.8 126.482 222.902 120.992 229.351C113.584 238.146 110.439 241.717 108.2 242.143Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M123.445 205.739C122.752 205.899 122.059 205.526 121.899 204.886C120.46 200.356 130.427 189.909 131.333 189.376C132.08 188.95 132.986 189.003 133.412 189.589C134.105 190.549 133.305 191.721 131.973 193.64L131.706 194.013C131.28 194.599 130.587 194.972 129.947 194.919C127.496 197.957 124.564 202.168 124.991 203.501C125.257 204.3 124.724 205.206 123.871 205.633C123.711 205.686 123.605 205.739 123.445 205.739Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M106.335 240.704C105.962 240.757 105.642 240.757 105.322 240.651C104.309 240.331 103.616 239.638 103.297 238.519C101.804 233.189 111.078 217.891 116.728 209.257C117.261 208.457 118.274 208.084 119.02 208.457C119.766 208.83 119.926 209.736 119.393 210.536C110.865 223.595 105.642 234.255 106.441 237.186C106.495 237.293 106.495 237.399 106.548 237.453C108.253 236.333 112.784 231.003 116.782 226.26C122.378 219.704 129.36 211.495 135.863 205.526C136.609 204.886 137.622 204.833 138.155 205.366C138.688 205.952 138.581 206.965 137.835 207.604C131.492 213.361 124.617 221.463 119.127 227.912C111.718 236.706 108.52 240.278 106.335 240.704Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M121.578 204.3C120.885 204.46 120.192 204.087 120.032 203.447C118.593 198.917 128.56 188.47 129.466 187.937C130.212 187.51 131.118 187.564 131.545 188.15C132.238 189.109 131.438 190.282 130.106 192.201L129.839 192.574C129.413 193.16 128.72 193.533 128.08 193.48C125.628 196.518 122.697 200.729 123.123 202.061C123.39 202.861 122.857 203.767 122.004 204.193C121.844 204.247 121.684 204.3 121.578 204.3Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M144.603 232.07C144.124 232.176 143.75 232.069 143.377 231.91C138.9 229.618 144.283 220.663 152.652 208.138C143.964 216.293 133.463 228.338 129.306 233.029C128.773 233.615 127.974 233.882 127.334 233.669C126.694 233.455 126.374 232.816 126.534 232.07C127.547 227.912 132.451 218.371 141.405 202.861L141.672 202.435C142.151 201.635 143.164 201.209 143.91 201.528C144.657 201.848 144.923 202.754 144.443 203.554L144.177 203.98C139.113 212.721 135.329 219.597 132.877 224.554C141.618 214.8 151.905 203.927 158.568 199.343C159.208 198.917 160.007 198.863 160.54 199.29C161.02 199.716 161.126 200.462 160.7 201.155C159.581 202.968 158.035 205.313 156.223 207.978C152.758 213.095 143.91 226.206 144.976 228.658C148.388 226.473 160.593 213.095 167.309 205.686C171.253 201.369 174.611 197.637 176.477 195.825C177.17 195.132 178.182 195.026 178.769 195.559C179.355 196.092 179.248 197.104 178.556 197.797C176.797 199.556 173.439 203.234 169.548 207.498C152.332 226.526 147.108 231.59 144.603 232.07Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M142.685 230.684C142.206 230.791 141.832 230.684 141.459 230.524C136.982 228.232 142.365 219.278 150.734 206.752C142.046 214.907 131.545 226.953 127.388 231.643C126.855 232.23 126.056 232.496 125.416 232.283C124.776 232.07 124.457 231.43 124.616 230.684C125.629 226.527 130.533 216.986 139.487 201.475L139.754 201.049C140.233 200.25 141.246 199.823 141.992 200.143C142.739 200.463 143.005 201.369 142.525 202.168L142.259 202.595C137.195 211.336 133.411 218.212 130.959 223.169C139.7 213.415 149.987 202.541 156.65 197.958C157.29 197.531 158.089 197.478 158.622 197.904C159.102 198.331 159.208 199.077 158.782 199.77C157.663 201.582 156.117 203.927 154.305 206.592C150.84 211.709 141.992 224.821 143.058 227.273C146.47 225.087 158.675 211.709 165.391 204.3C169.335 199.983 172.693 196.252 174.559 194.44C175.252 193.747 176.264 193.64 176.851 194.173C177.437 194.706 177.33 195.719 176.638 196.412C174.879 198.171 171.521 201.849 167.63 206.113C150.467 225.087 145.244 230.204 142.685 230.684Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M208.565 221.037C208.085 221.143 207.712 221.037 207.339 220.877C202.862 218.585 208.245 209.63 216.613 197.105C207.925 205.26 197.425 217.306 193.267 221.996C192.734 222.582 191.935 222.849 191.295 222.636C190.656 222.423 190.336 221.783 190.496 221.037C191.509 216.879 196.412 207.339 205.367 191.828L205.633 191.402C206.113 190.602 207.126 190.176 207.872 190.496C208.618 190.815 208.884 191.722 208.405 192.521L208.138 192.947C203.075 201.689 199.29 208.564 196.839 213.521C205.58 203.767 215.867 192.894 222.529 188.31C223.169 187.884 223.968 187.831 224.501 188.257C224.981 188.683 225.088 189.43 224.661 190.123C223.542 191.935 221.996 194.28 220.184 196.945C216.72 202.062 207.872 215.174 208.938 217.626C212.349 215.44 224.555 202.062 231.271 194.653C235.215 190.336 238.573 186.605 240.438 184.793C241.131 184.1 242.144 183.993 242.73 184.526C243.316 185.059 243.21 186.072 242.517 186.765C240.758 188.524 237.4 192.201 233.509 196.465C216.293 215.494 211.07 220.61 208.565 221.037Z",
                fill: "#D3D3D3"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M206.645 219.65C206.165 219.757 205.792 219.65 205.419 219.49C200.942 217.198 206.325 208.244 214.694 195.718C206.006 203.873 195.505 215.919 191.348 220.61C190.815 221.196 190.016 221.463 189.376 221.249C188.736 221.036 188.416 220.396 188.576 219.65C189.589 215.493 194.493 205.952 203.447 190.442L203.714 190.015C204.193 189.216 205.206 188.789 205.952 189.109C206.699 189.429 206.965 190.335 206.485 191.135L206.219 191.561C201.155 200.302 197.371 207.178 194.919 212.135C203.66 202.381 213.947 191.508 220.61 186.924C221.249 186.498 222.049 186.444 222.582 186.871C223.062 187.297 223.168 188.043 222.742 188.736C221.623 190.548 220.077 192.894 218.265 195.559C214.8 200.675 205.952 213.787 207.018 216.239C210.43 214.054 222.635 200.675 229.351 193.267C233.295 188.949 236.653 185.218 238.519 183.406C239.212 182.713 240.224 182.607 240.811 183.14C241.397 183.673 241.29 184.685 240.598 185.378C238.839 187.137 235.481 190.815 231.59 195.079C214.427 214.054 209.204 219.171 206.645 219.65Z",
                fill: "#FEF5FF"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint0_radial_193_720",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(174.512 161.507) scale(161.507)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F24E61"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4064",
                                stopColor: "#EA4B5E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5376",
                                stopColor: "#EC3369",
                                stopOpacity: "0.779"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7147",
                                stopColor: "#EE1975",
                                stopOpacity: "0.4807"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8742",
                                stopColor: "#F0097C",
                                stopOpacity: "0.2119"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F0047F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1687",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1699",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1689",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint5_linear_193_720",
                        x1: "174.407",
                        y1: "273.106",
                        x2: "174.407",
                        y2: "38.1703",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint6_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint7_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1704",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint8_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1694",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint9_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1692",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint10_linear_193_720",
                        x1: "174.407",
                        y1: "273.105",
                        x2: "174.407",
                        y2: "38.1697",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint11_linear_193_720",
                        x1: "244.791",
                        y1: "106.979",
                        x2: "244.791",
                        y2: "177.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint12_linear_193_720",
                        x1: "244.788",
                        y1: "108.924",
                        x2: "244.788",
                        y2: "174.972",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint13_linear_193_720",
                        x1: "244.788",
                        y1: "143.446",
                        x2: "244.788",
                        y2: "174.611",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint14_linear_193_720",
                        x1: "310.323",
                        y1: "107.544",
                        x2: "310.323",
                        y2: "178.56",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint15_linear_193_720",
                        x1: "309.598",
                        y1: "109.489",
                        x2: "309.598",
                        y2: "175.536",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint16_linear_193_720",
                        x1: "309.484",
                        y1: "138.355",
                        x2: "309.484",
                        y2: "174.728",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint17_linear_193_720",
                        x1: "189.764",
                        y1: "108.736",
                        x2: "189.764",
                        y2: "179.751",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint18_linear_193_720",
                        x1: "189.764",
                        y1: "110.681",
                        x2: "189.764",
                        y2: "176.728",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint19_linear_193_720",
                        x1: "189.764",
                        y1: "137.472",
                        x2: "189.764",
                        y2: "175.843",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint20_linear_193_720",
                        x1: "52.72",
                        y1: "107.769",
                        x2: "52.72",
                        y2: "180.304",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint21_linear_193_720",
                        x1: "52.7199",
                        y1: "110.102",
                        x2: "52.7199",
                        y2: "176.426",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint22_linear_193_720",
                        x1: "31.2159",
                        y1: "144.708",
                        x2: "31.2159",
                        y2: "177.453",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint23_linear_193_720",
                        x1: "74.3681",
                        y1: "145.253",
                        x2: "74.3681",
                        y2: "177.46",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint24_linear_193_720",
                        x1: "131.292",
                        y1: "108.069",
                        x2: "131.292",
                        y2: "180.604",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint25_linear_193_720",
                        x1: "131.292",
                        y1: "110.402",
                        x2: "131.292",
                        y2: "176.725",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint26_linear_193_720",
                        x1: "131.292",
                        y1: "141.221",
                        x2: "131.292",
                        y2: "177.112",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Icon;
